module.exports = __webpack_public_path__ + "static/media/38.10a2d11.wav";


//////////////////
// WEBPACK FOOTER
// ./src/assets/audio/38.wav
// module id = saWv
// module chunks = 0